module.exports = __webpack_public_path__ + "img/instagram.c06dc1bd.svg";